export enum PatientEventName {
  /**
   * Sleep
   */
  CHANGE_IN_TOTAL_SLEEPING_TIME_20_PERCENT_OR_MORE = 'change-in-tst-20-percent-or-more',
  SLEEP_SHIFTING = 'sleep-shifting',
  MAJOR_INTERRUPTION_2_OR_MORE = 'major-interruption-2-or-more',
  CHANGE_IN_NUM_OF_AWAKENING_20_PERCENT_OR_MORE = 'change-in-num-of-awakening-20-percent-or-more',
  SLEEP_CHANGE_CONSOLIDATED = 'sleep-change-consolidated',
  INTERRUPTION_IN_SLEEP_CONSOLIDATED = 'interruption-in-sleep-consolidated',

  /**
   * Activity
   */
  LESS_THAN_15_MIN_WALK_PER_DAY = 'less-than-15-min-walk-per-day',
  LESS_THAN_500_METERS_WALK_PER_DAY = 'less-than-500-meters-walk-per-day',
  LESS_THAN_500_WALK_STEPS_PER_DAY = 'less-than-500-walk-steps-per-day',
  WALK_STEPS_DROPS_MORE_THAN_50_PERCENT = 'walk-steps-drops-more-than-50-percent',
  LESS_THAN_15_MIN_HIGH_ACTIVITY_PER_DAY = 'less-than-15-min-high-activity-per-day',
  SEDENTARY_MORE_THAN_2_HOURS_PER_DAY = 'sedentary-more-than-2-hours-per-day',
  NO_MOVEMENT_CONSOLIDATED = 'no-movement-consolidated',

  /**
   * Inhaler
   */
  RELIEVER_USAGE_5_OR_MORE_TIMES_PER_DAY = 'reliever-usage-5-or-more-times-per-day',
  RELIEVER_5_OR_MORE_PUFFS_PER_USAGE = 'reliever-5-or-more-puffs-per-usage',
  RELIEVER_4_OR_MORE_PUFFS_PER_USAGE = 'reliever-4-or-more-puffs-per-usage',
  RELIEVER_SUDDEN_CHANGE = 'reliever-sudden_change',
  RELIEVER_USAGE_DURING_SLEEP = 'reliever-inhaler-usage-during-sleep',
  RELIEVER_OVER_DOSAGE_CONSOLIDATED = 'reliever-over-dosage-consolidated',

  MAINTENANCE_MISSING_USAGE = 'maintenance-missing-usage',
  MAINTENANCE_SUDDEN_CHANGE = 'maintenance-sudden_change',
  MAINTENANCE_5_OR_MORE_PUFFS_PER_USAGE = 'maintenance-5-or-more-puffs-per-usage',
  MAINTENANCE_MORE_THAN_2_PUFFS_PER_USAGE = 'maintenance-more-than-2-puffs-per-usage',
  MAINTENANCE_USAGE_5_OR_MORE_TIMES_PER_DAY = 'maintenance-usage-5-or-more-times-per-day',
  MAINTENANCE_USAGE_MORE_THAN_2_TIMES_PER_DAY = 'maintenance-usage-more-than-2-times-per-day',
  MAINTENANCE_2_PUFFS_OR_LESS_PER_DAY = 'maintenance-2-or-less-puffs-per-day',
  MAINTENANCE_INHALER_NON_ADHERENCE = 'maintenance-inhaler-non-compliance-consolidated',

  /**
   * Correlated
   */
  SHORTNESS_OF_BREATH = 'shortness-of-breath',
  NEEDS_UPDATE = 'needs-update',

  /**
   * Live
   */
  NO_MOVEMENT = 'no-movement',
  BED_SORE = 'bed-sore',
  REALTIME_SLEEP_INTERRUPTION = 'realtime-sleep-interruption',
  WALKING_AT_NIGHT = 'walking-at-night',
  FALL_DETECTED = 'fall',
}

export const PATIENT_EVENT_CODES = {
  30104: PatientEventName.SLEEP_CHANGE_CONSOLIDATED,
  30202: PatientEventName.INTERRUPTION_IN_SLEEP_CONSOLIDATED,
  // todo, add more... actually we should probably load this from Kalamalka/DDB
}

export const ALL_PATIENT_EVENT_VMS = {
  /**
   * Sleep
   */
  [PatientEventName.CHANGE_IN_NUM_OF_AWAKENING_20_PERCENT_OR_MORE]: 'Significant change in number of awakenings',
  [PatientEventName.CHANGE_IN_TOTAL_SLEEPING_TIME_20_PERCENT_OR_MORE]: 'Significant change in total sleep time',
  [PatientEventName.SLEEP_SHIFTING]: 'Significant shift in sleep pattern',
  [PatientEventName.MAJOR_INTERRUPTION_2_OR_MORE]: 'Major interruptions during sleep',
  [PatientEventName.SLEEP_CHANGE_CONSOLIDATED]: 'Sleep onset/offset change',
  [PatientEventName.INTERRUPTION_IN_SLEEP_CONSOLIDATED]: 'Sleep interruptions',

  /**
   * Activity
   */
  [PatientEventName.LESS_THAN_15_MIN_WALK_PER_DAY]: 'Very little walking time',
  [PatientEventName.LESS_THAN_500_METERS_WALK_PER_DAY]: 'Very short walking distance',
  [PatientEventName.LESS_THAN_500_WALK_STEPS_PER_DAY]: 'Very few walking steps',
  [PatientEventName.WALK_STEPS_DROPS_MORE_THAN_50_PERCENT]: 'Significant drop in walking steps',
  [PatientEventName.LESS_THAN_15_MIN_HIGH_ACTIVITY_PER_DAY]: 'Very short active time',
  [PatientEventName.SEDENTARY_MORE_THAN_2_HOURS_PER_DAY]: 'Very long sedentary time',
  [PatientEventName.NO_MOVEMENT_CONSOLIDATED]: 'No Movement',

  /**
   * Inhaler
   */
  [PatientEventName.RELIEVER_USAGE_5_OR_MORE_TIMES_PER_DAY]: 'Too many reliever usages per day',
  [PatientEventName.RELIEVER_5_OR_MORE_PUFFS_PER_USAGE]: 'Too many puffs per reliever usage',
  [PatientEventName.RELIEVER_4_OR_MORE_PUFFS_PER_USAGE]: 'Too many puffs per reliever usage',
  [PatientEventName.RELIEVER_SUDDEN_CHANGE]: 'Sudden change in reliever usages',
  [PatientEventName.RELIEVER_USAGE_DURING_SLEEP]: 'Reliever usage during sleep',
  [PatientEventName.RELIEVER_OVER_DOSAGE_CONSOLIDATED]: 'Reliever over dosage for 2 of last 5 days',

  [PatientEventName.MAINTENANCE_MISSING_USAGE]: 'Missing maintenance inhaler usage',
  [PatientEventName.MAINTENANCE_SUDDEN_CHANGE]: 'Sudden change in maintenance inhaler usage',
  [PatientEventName.MAINTENANCE_5_OR_MORE_PUFFS_PER_USAGE]: 'Too many puffs per maintenance inhaler usage',
  [PatientEventName.MAINTENANCE_MORE_THAN_2_PUFFS_PER_USAGE]: 'Too many puffs per maintenance inhaler usage',
  [PatientEventName.MAINTENANCE_USAGE_5_OR_MORE_TIMES_PER_DAY]: 'Too many maintenance inhaler usages per day',
  [PatientEventName.MAINTENANCE_USAGE_MORE_THAN_2_TIMES_PER_DAY]: 'Too many maintenance inhaler usages per day',
  [PatientEventName.MAINTENANCE_2_PUFFS_OR_LESS_PER_DAY]: 'Very few maintenance inhaler puffs per day',
  [PatientEventName.MAINTENANCE_INHALER_NON_ADHERENCE]: 'Maintenance inhaler non-adherence',
  /**
   * Correlated
   */
  [PatientEventName.SHORTNESS_OF_BREATH]: 'Shortness of breath',

  /**
   * Live events
   */
  [PatientEventName.NO_MOVEMENT]: 'No movement',
  [PatientEventName.REALTIME_SLEEP_INTERRUPTION]: 'Sleep interrupted',
  [PatientEventName.WALKING_AT_NIGHT]: 'Walking at night',

  [PatientEventName.FALL_DETECTED]: 'Fall detected',
  [PatientEventName.BED_SORE]: 'No movement for the past 2 hours',

  [PatientEventName.NEEDS_UPDATE]: 'Needs update',
}

export const ALL_PATIENT_EVENT_DESCRIPTIONS = {
  /**
   * Sleep
   */
  [PatientEventName.SLEEP_CHANGE_CONSOLIDATED]:
    'Time to go to bed and getting up in the morning has changed significantly compared to previous nights (2 nights in a row)',
  [PatientEventName.INTERRUPTION_IN_SLEEP_CONSOLIDATED]: '2+ times waking up for over 30 minutes (2 nights in a row)',
  [PatientEventName.MAINTENANCE_INHALER_NON_ADHERENCE]: 'Maintenance inhaler non-adherence for 2 of past 5 days',

  /* Moving from a live event to a consolidated event */
  [PatientEventName.NO_MOVEMENT]:
    'No movement detected. Tracker may have been removed, or resident may have passed away',
  [PatientEventName.NO_MOVEMENT_CONSOLIDATED]:
    'No movement detected. Tracker may have been removed, or resident may have passed away',
}

export const MAP_EVENT_DESCRIPTIONS = {
  /**
   * Sleep
   */
  [PatientEventName.SLEEP_CHANGE_CONSOLIDATED]: 'Risk of fall',
  [PatientEventName.INTERRUPTION_IN_SLEEP_CONSOLIDATED]: 'Risk of fall',
}

export function getFriendlyEventName(eventName): string {
  return ALL_PATIENT_EVENT_VMS[eventName] || eventName || ''
}

// not coalescing because we don't want to show the icon if it's null
export function getEventDescription(eventName): string {
  return ALL_PATIENT_EVENT_DESCRIPTIONS[eventName]
}

export function getMapEventName(eventName): string {
  return MAP_EVENT_DESCRIPTIONS[eventName]
}
